/**
 * attendanceMode.js
 * Modalidade do agendamento: presencial (ocupa sala) ou online (link de
 * videochamada opcional). Valores iguais aos do banco (`attendance_mode`).
 * Especificação: docs/features/modalidade-de-atendimento/README.md
 */

export const ATTENDANCE_IN_PERSON = 'in_person';
export const ATTENDANCE_ONLINE = 'online';

export const ATTENDANCE_MODE_OPTIONS = [
  { id: ATTENDANCE_IN_PERSON, label: 'Presencial' },
  { id: ATTENDANCE_ONLINE, label: 'Online' },
];

export const MEETING_URL_ERROR = 'Informe um link válido, começando com http:// ou https://';

/** Modalidade válida a partir de qualquer valor (ausente = presencial) */
export function normalizeAttendanceMode(value) {
  return value === ATTENDANCE_ONLINE ? ATTENDANCE_ONLINE : ATTENDANCE_IN_PERSON;
}

export function isOnlineAppointment(appointment) {
  return appointment?.attendance_mode === ATTENDANCE_ONLINE;
}

export function attendanceModeLabel(mode) {
  return mode === ATTENDANCE_ONLINE ? 'Online' : 'Presencial';
}

/**
 * Link da videochamada: vazio é aceito (opcional); com valor, só http ou https com host.
 * Mesma regra do backend (AppointmentAttendanceMode::parseMeetingUrl).
 */
export function isValidMeetingUrl(value) {
  const url = String(value || '').trim();
  if (!url) return true;
  if (!/^https?:\/\//i.test(url) || /\s/.test(url)) return false;
  try {
    const parsed = new URL(url);
    return (parsed.protocol === 'https:' || parsed.protocol === 'http:') && Boolean(parsed.hostname);
  } catch (e) {
    return false;
  }
}
